import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoTig: CultureInfo = {
  name: 'tig',
  displayName: 'ትግረ',
  iso3LanguageCode: 'tig',
  iso2LanguageCode: 'tig',
  ietfLanguageTag: 'tig',
  parent: null
};
